import React from "react";

function Header() {

  return (
    <header>
      <h1>🎬 Movie Collection Manager</h1>
      <p>Add, Edit and Manage your favorite movies</p>
    </header>
  );

}

export default Header;